import api from 'data/api';

export const loadApplications = api('GET /api/mobile/lookups/applications');
